import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import LazyLoad, { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import Loadable from 'react-loadable';
import { handleTime } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/formatDate';
import { formatTimeBySecdStr } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/utils';
import styles from './index.css';

const LoadVideo = Loadable({
    loader: () => import('../video'),
    loading() {
        return <div />;
    },
});

/**
 * 定义 Item 组件
 */
class Item extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        index: PropTypes.number,
    };

    state = {
        item: this.props.item,
        index: this.props.index,
        isShowVTime: true,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.item !== state.item) {
            return {
                item: props.item,
            };
        }

        return null;
    }

    handleVTime = canPlay => {
        if (!canPlay) return;
        this.setState(
            {
                isShowVTime: false,
            },
            () => {
                if (canPlay) {
                    canPlay.play();
                    console.log('===after==', this.state.isShowVTime);
                }
            },
        );
    };

    componentDidMount() {}
    componentWillUnmount() {}

    render() {
        const { item, index, isShowVTime } = this.state;

        const videoDom = (
            // <div className={styles.videoRadius}>
            //     <LazyLoad key={index}>
            //         <LoadVideo item={item} />
            //     </LazyLoad>
            // </div>
            <div className={`${styles.videoBox} ${isShowVTime ? '' : styles.hideVTime}`}>
                <LazyLoad key={index}>
                    <LoadVideo item={item} funTime={canPlay => this.handleVTime(canPlay)} />
                </LazyLoad>
                <span className={styles.videoTime}>{formatTimeBySecdStr(item.duration)}</span>
            </div>
        );
        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>';

        const bigDom =
            item.type === 'video' || item.type === 'phvideo' ? (
                <React.Fragment>
                    <a className={`${styles.itemJump} ${styles.imgBigBox}`} href={item.url}>
                        <span className={styles.newsTime}>{handleTime(item.newsTime)}</span>
                        <h2 className={styles.newTt}>{item.title}</h2>
                        <div className={styles.flcontBox}>
                            <p className={styles.newCont}>{item.summary}</p>
                        </div>
                    </a>
                    <div className={styles.imgBigBox}>
                        {videoDom}
                        {/*  no play for video
                        <div className={styles.videoBox}>
                            <LazyImg
                                placeholder={loadImgUrl}
                                // src={formatImage(item.thumbnail, 226, 150)}
                                src={item.thumbnail}
                                width="644"
                                height="364"
                            />
                            <span className={styles.videoTime}>{formatTimeBySecdStr(item.duration)}</span>
                        </div> */}
                    </div>
                </React.Fragment>
            ) : (
                <a className={styles.itemJump} href={item.url}>
                    <span className={styles.newsTime}>{handleTime(item.newsTime)}</span>
                    <div className={styles.imgBigBox}>
                        <h2 className={styles.newTt}>{item.title}</h2>
                        <div className={styles.flcontBox}>
                            <p className={styles.newCont}>{item.summary}</p>
                        </div>

                        <LazyImg
                            placeholder={loadImgUrl}
                            src={item.thumbnailBig || item.thumbnail}
                            width="644"
                            height="364"
                        />
                    </div>
                </a>
            );

        const smallDom =
            item.type === 'video' || item.type === 'phvideo' ? (
                <div className={styles.mixBox}>
                    <div className={styles.flcontBox}>
                        <h2 className={styles.newTt}>{item.title}</h2>
                    </div>
                    <div className={styles.videoBox}>
                        <LazyImg
                            placeholder={loadImgUrl}
                            // src={formatImage(item.thumbnail, 226, 150)}
                            src={item.thumbnail}
                            width="226"
                            height="150"
                        />
                        <span className={styles.videoTime}>{formatTimeBySecdStr(item.duration)}</span>
                    </div>
                </div>
            ) : (
                <div className={styles.mixBox}>
                    <div className={styles.flcontBox}>
                        <h2 className={styles.newTt}>{item.title}</h2>
                    </div>
                    <LazyImg placeholder={loadImgUrl} src={item.thumbnail} width="226" height="150" />
                </div>
            );

        const imgVideoDom =
            (item.newStyle && item.newStyle === 'bigimg') || item.newStyle === 'twbigimg' ? (
                bigDom
            ) : (
                <a className={styles.itemJump} href={item.url}>
                    <span className={styles.newsTime}>{handleTime(item.newsTime)}</span>
                    {smallDom}
                </a>
            );

        // {item.type === 'phvideo' ? videoDom : imgDom}

        const domInfo =
            item.newStyle && item.newStyle === 'twsingletitle' ? (
                <p className={styles.newCont}>{item.summary}</p>
            ) : null;

        const domMix =
            item.newStyle === 'twsingletitle' ? (
                <a className={styles.itemJump} href={item.url}>
                    <span className={styles.newsTime}>{handleTime(item.newsTime)}</span>
                    <h2 className={styles.newTt}>{item.title}</h2>
                    {domInfo}
                </a>
            ) : (
                imgVideoDom
            );

        return (
            <div
                className={styles.itemWrap}
                key={index}
                ref={item.ref}
                data-type={item.type}
                data-time={item.newsTime}
                data-title={item.title}>
                {domMix}
            </div>
        );
    }
}

export default errorBoundary(Item);
